import React, { useState, useEffect, useRef } from 'react';

import axios from 'axios';

import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
import { useTranslation } from 'react-i18next';

import {
  TextField,
  PrimaryButton,
  Dropdown,
  Stack,
  getTheme,
  Icon,
  Spinner,
  MessageBar,
  MessageBarType,
  Separator,
  Toggle,
  IconButton,
} from '@fluentui/react';

import { Tab, TabList } from "@fluentui/react-components";

import { useLocation, useHistory } from 'react-router-dom';
import { getAccountTypeList, getBankList } from '../../providers/BankData';

const API_URL = process.env.REACT_APP_API_URL;

const theme = getTheme();

const homeStyles = {
  border: 0,
  margin: 0,
  width: '100%',
  minWidth: 'calc(100vw - 310px)',
  background: '#FAF9F8',
  position: 'relative',
};

const cardStyle = {
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 20,
  paddingBottom: 30,
  background: '#ffffff',
  marginLeft: '0',
  marginTop: '10px',
  boxShadow: theme.effects.elevation4,
};

// Processing dialog style
const spinnerStyles = {
  circle: {
    height: 56,
    width: 56,
    borderWidth: 4,
  },
};

const PaymentMethods = () => {
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const history = useHistory();

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const [isLoading, setIsLoading] = useState(true);

  const [showMessageBarSuccess, setShowMessageBarSuccess] = useState(false);
  const [showMessageBarError, setShowMessageBarError] = useState(false);

  const [notSubscribed, setNotSubscribed] = useState(false)

  const [enableBillPayment, setEnableBillPayment] = useState(false);
  const [displayBillPayment, setDisplayBillPayment] = useState(false)
  const [enabledSpecificAmount, setEnabledSpecificAmount] = useState(false)
  const [enabledReference, setEnabledReference] = useState(false)
  const [taxId, setTaxId] = useState('')
  const [suffix, setSuffix] = useState('')
  const [ref1, setRef1] = useState('')
  const [ref2, setRef2] = useState('')

  const [paymentDisplay, setPaymentDisplay] = useState(false)
  const [paymentLanguage, setPaymentLanguage] = useState('th')
  const bankList = getBankList(i18n.language)
  const accountTypeList = getAccountTypeList(i18n.language)
  
  const [accountName, setAccountName] = useState('');
  const [banks, setBanks] = useState([
    {
      bankCode: '',
      bankName: '',
      branch: '',
      typeCode: '',
      typeName: '',
      accountNumber: '',
    },
  ]);
  const [paymentNote, setPaymentNote] = useState('');
  const [promptpay, setPromptpay] = useState(false);

  const companyId = sessionStorage.getItem('companyId') || '';

  const [currentTab, setCurrentTab] = useState(location.state?.tab || 'payment')

  const [getPaymentMethodsSuccess, setGetPaymentMethodsSuccess] = useState(false)
  const [getBillPaymentSuccess, setGetBillPaymentSuccess] = useState(false)

  let refArray = useRef({
    taxId: '',
    suffix: '',
    ref1: '',
    ref2: '',
  });

  const [showBankError, setShowBankError] = useState(false)

  useEffect(() => {
    if (getPaymentMethodsSuccess && getBillPaymentSuccess) {
      setIsLoading(false)
    } else {
      setIsLoading(true)
    }
  }, [getPaymentMethodsSuccess, getBillPaymentSuccess])
  

  useEffect(() => {
    //Check documents spending limit
    if (currentTab === 'payment') {
      getPaymentMethods()
    } else if (currentTab === 'billPayment') {
      getBillPayment()
    } else {
      history.push({
        pathname: '/etax/companies/profiles',
        state: {},
      });
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab])

  useEffect(() => {
    getPaymentMethods()
    getBillPayment()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getErrorMessageWithMaxLength = (value, maxLength, required, extraError) => {
    if (extraError) return extraError
    if (isNaN(value)) return t('paymentMethods.getRefErrorMessage');
    if (value.length > maxLength) return t('paymentMethods.getErrorMessageExceedMaxLength') + maxLength + t('billingNote.getErrorMessageExceedMaxLength2');
    if (!required) return ""
    if (value && value !== '0') return ""
    return value && value !== '0' ? '' : t('paymentMethods.getErrorMessage');
  };

  const getErrorMessageNoMaxLength = (value, required, extraError) => {
    if (extraError) return extraError
    if (isNaN(value)) return t('paymentMethods.getRefErrorMessage');
    if (!required) return ""
    if (value && value !== '0') return ""
    return value && value !== '0' ? '' : t('paymentMethods.getErrorMessage');
  };

  const getErrorMessage = (value, required) => {
    if (!required) return ""
    if (required) {
      if (!value) return t('paymentMethods.getErrorMessage')
    }
    if (value && value !== '0') return ""
    return value && value !== '0' ? '' : t('paymentMethods.getErrorMessage');
  };
  
  const getErrorMessageDropdown = (value, required) => {
    if (!required) return ""
    if (required) {
      if (!value) return t('paymentMethods.pleaseSelect')
    }
  };

  function getPaymentMethods() {
    setGetPaymentMethodsSuccess(false)

    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then((tokenResponse) => {
      axios.get(API_URL + '/etax/companies', {
        headers: {
          Authorization: 'Bearer ' + tokenResponse.accessToken,
        },
      })
      .then(
        (response) => {
          console.log(response);
  
          if (response.data[0]) {
            if (companyId && response.data.find(_company => _company.id === companyId)) {
              const _company = response.data.find(_company => _company.id === companyId)
  
              if (_company.payment && _company.payment.accountName) {
                setPaymentDisplay(_company.payment.display);
                setAccountName(_company.payment.accountName);
  
                let _banks = [];
  
                if (_company.payment.banks.length > 0) {
                  _company.payment.banks.forEach((bank, index) => {
                    _banks.push({
                      bankCode: bank.bankCode,
                      bankName: bank.bankName,
                      branch: bank.branch,
                      typeCode: bank.typeCode,
                      typeName: bank.typeName,
                      accountNumber: bank.accountNumber,
                    });
                  });
  
                  setBanks(_banks);
                }
                setPaymentNote(_company.payment.note);
  
                setPromptpay(_company.payment.promptpay);
              }
            } else {
              if (response.data[0].payment && response.data[0].payment.accountName) {
                setPaymentDisplay(response.data[0].payment.display);
                setAccountName(response.data[0].payment.accountName);
  
                let _banks = [];
  
                if (response.data[0].payment.banks.length > 0) {
                  response.data[0].payment.banks.forEach((bank, index) => {
                    _banks.push({
                      bankCode: bank.bankCode,
                      bankName: bank.bankName,
                      branch: bank.branch,
                      typeCode: bank.typeCode,
                      typeName: bank.typeName,
                      accountNumber: bank.accountNumber,
                    });
                  });
  
                  setBanks(_banks);
                }
                setPaymentNote(response.data[0].payment.note);
  
                setPromptpay(response.data[0].payment.promptpay);
              }
            }
          } else {
            history.push({
              pathname: '/etax/companies/profiles',
              state: {},
            });
          }
  
          setGetPaymentMethodsSuccess(true)
        },
        (error) => {
          console.log(error);
        }
      );
    })
  }

  function getBillPayment() {
    setGetBillPaymentSuccess(false)

    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then((tokenResponse) => {
      axios.get(API_URL + '/companies-details', {
        headers: {
          Authorization: 'Bearer ' + tokenResponse.accessToken,
          cid: companyId
        },
      })
      .then(
        (response) => {
          console.log('Companies details data: ', response);

          if (response.data.billings.type === 'subscription') {
            if (response.data.payments) {
              setEnableBillPayment(response.data.payments?.billPayments?.enabled)
              setDisplayBillPayment(response.data.payments?.billPayments?.display)
              setEnabledSpecificAmount(response.data.payments?.billPayments?.enabledSpecificAmount)
              setEnabledReference(response.data.payments?.billPayments?.enabledReference)
              setTaxId(response.data.payments?.billPayments?.taxId)
              setSuffix(response.data.payments?.billPayments?.suffix)
              setRef1(response.data.payments?.billPayments?.ref1)
              setRef2(response.data.payments?.billPayments?.ref2)
            } else {
              setEnableBillPayment(true)
            }
          } else {
            setNotSubscribed(true)
          }

          setGetBillPaymentSuccess(true)

        },
        (error) => {
          console.log(error);
        }
      );
    })
  }

  function handleSubmitPayment(event) {
    event.preventDefault();

    setShowBankError(false)

    setShowMessageBarError(false)
    setShowMessageBarSuccess(false)

    let isCorrect = true;

    if (banks.length) {
      banks.forEach(_bank => {
        if (!_bank.bankCode) {
          isCorrect = false;
        }

        if (!_bank.branch) {
          isCorrect = false;
        }

        if (!_bank.typeCode) {
          isCorrect = false;
        }

        if (!_bank.accountNumber) {
          isCorrect = false;
        }
      })
    }

    if (!isCorrect) {
      setShowBankError(true)
    }

    if (isCorrect) {
      setIsLoading(true)
  
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
        // .put(`${API_URL}/companies-details/billings/` + companyId, {
        .patch(API_URL + '/etax/companies/' + companyId, {
          replace: 'payment',
          value: {
            accountName: accountName,
            banks: banks,
            display: paymentDisplay,
            language: paymentLanguage,
            note: paymentNote,
            promptpay: promptpay
          }
        }, {
          headers: {
            Authorization: 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'application/json',
            'cid': companyId
          },
        })
        .then(
          (response) => {
            console.log('response handleSubmitPayment', response);
  
            setShowMessageBarSuccess(true)
            setIsLoading(false)
          },
          (error) => {
            console.log("error handleSubmit", error);
  
            setShowMessageBarError(true)
            setIsLoading(false)
          }
        );
      })
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    setShowMessageBarError(false)
    setShowMessageBarSuccess(false)

    let isCorrect = true;

    if (taxId?.length !== 13) {
      isCorrect = false;

      refArray.current.taxId.focus();
      refArray.current.taxId.blur();
    }

    if (suffix?.length !== 2) {
      isCorrect = false;

      refArray.current.suffix.focus();
      refArray.current.suffix.blur();
    }

    if (enabledReference) {
      if (ref1?.length > 18) {
        isCorrect = false;

        refArray.current.ref1.focus();
        refArray.current.ref1.blur();
      }
  
      if (ref2?.length > 18) {
        isCorrect = false;

        refArray.current.ref2.focus();
        refArray.current.ref2.blur();
      }

      if (isNaN(ref1)) {
        isCorrect = false;
      }

      if (isNaN(ref2)) {
        isCorrect = false;
      }

      if (!ref1) {
        isCorrect = false;
      }

      if (!ref2) {
        isCorrect = false;
      }
    }

    if (isCorrect) {
      setIsLoading(true)
  
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
        .put(`${API_URL}/companies-details/payments/bill-payments/` + companyId, {
        // .put(`http://localhost:7071/api/companies-details/payments/bill-payments/` + companyId, {
        // .put(`https://ws.uat-lcpt.com/companies-details/payments/bill-payments/` + companyId, {
            display: displayBillPayment,
            enabledSpecificAmount: enabledSpecificAmount,
            enabledReference: enabledReference,
            taxId: taxId,
            suffix: suffix,
            ref1: enabledReference ? ref1 : '',
            ref2: enabledReference ? ref2 : ''
        }, {
          headers: {
            Authorization: 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'application/json',
            'cid': companyId
          },
        })
        .then(
          (response) => {
            console.log('response handleSubmit', response);
  
            setShowMessageBarSuccess(true)
            setIsLoading(false)
          },
          (error) => {
            console.log("error handleSubmit", error);
  
            setShowMessageBarError(true)
            setIsLoading(false)
          }
        );
      })
    }
  }

  const handleChangeBankName = (index, event, selectedOption) => {
    console.log('Change index:', index);
    console.log('Event name: ', event);
    console.log('Selected option: ', selectedOption);
    const values = [...banks];
    if (selectedOption) {
      values[index]['bankCode'] = selectedOption.key;
      values[index]['bankName'] = selectedOption.text;
    }
    console.log('Banks: ', values);

    setBanks(values);
  };

  const handleChangeBankType = (index, event, selectedOption) => {
    console.log('Change index:', index);
    console.log('Event name: ', event);
    console.log('Selected option: ', selectedOption);
    const values = [...banks];
    if (selectedOption) {
      values[index]['typeCode'] = selectedOption.key;
      values[index]['typeName'] = selectedOption.text;
    }
    console.log('Banks: ', values);

    setBanks(values);
  };

  const handleChangeBank = (index, event, selectedOption) => {
    console.log('Change index:', index);
    console.log('Event name: ', event);
    console.log('Selected option: ', selectedOption);
    const values = [...banks];

    values[index][event.target.name] = event.target.value;

    console.log('Banks: ', values);

    setBanks(values);
  };

  const handleAddBank = () => {
    setBanks([
      ...banks,
      {
        bankCode: '',
        bankName: '',
        branch: '',
        typeCode: '',
        typeName: '',
        accountNumber: '',
      },
    ]);
  };

  const handleRemoveBank = (index) => {
    console.log('Delete index:', index);
    const values = [...banks];
    values.splice(index, 1);
    setBanks(values);
  };

  return (
    <div style={homeStyles}>
      {showMessageBarSuccess && (
        <MessageBar
          messageBarType={MessageBarType.success}
          isMultiline={false}
          onDismiss={() => setShowMessageBarSuccess(false)}
          dismissButtonAriaLabel="Close"
        >
          {t('paymentMethods.updateSuccess')}
        </MessageBar>
      )}
      {showMessageBarError && (
        <MessageBar
          messageBarType={MessageBarType.error}
          isMultiline={false}
          onDismiss={() => setShowMessageBarError(false)}
          dismissButtonAriaLabel="Close"
        >
          {t('paymentMethods.updateFail')}
        </MessageBar>
      )}

      <Stack horizontalAlign='center'>
        <Stack styles={{ root: { width: 677}}}>
          <Stack horizontal horizontalAlign='space-between'>
            <div>
              <h2 style={{ marginLeft: '0', marginTop: '27px' }}>
                <Icon iconName="M365InvoicingLogo" style={{ color: '#106ebe' }} /> {t("paymentMethods.paymentMethods")}
              </h2>
            </div>
          </Stack>
          <label>{t("paymentMethods.description")}</label>
          <br />
          <TabList 
            selectedValue={currentTab} 
            onTabSelect={(_, selectTab) => {
              setShowMessageBarError(false)
              setShowMessageBarSuccess(false)

              setCurrentTab(selectTab.value)
            }}
          >
            <Tab value="payment" disabled={isLoading}>{t("paymentMethods.bankAccount")}</Tab>
            <Tab value="billPayment" disabled={notSubscribed || !enableBillPayment || isLoading}>{t("paymentMethods.billPaymentSetting")}</Tab>
          </TabList>
          {currentTab === "payment" ? (
            isLoading ? (
              <Stack>
                <Stack horizontal horizontalAlign="center" style={{ marginTop: '25px', width: 617 }}>
                  <br />
                  <br />
                  <div>
                    <Spinner label={t('paymentMethods.loading')} labelPosition="down" styles={spinnerStyles} />
                  </div>
                  <br />
                </Stack>
              </Stack>
            ) : (
              <div>
                <form>
                  <div style={cardStyle}>
                    <Stack horizontal horizontalAlign='space-between'>
                      <Stack>
                        <label style={{ fontWeight: 600, color: "#323130", padding: "5px 0px"}}>{t('paymentMethods.displayPaymentChannel')}</label>
                      </Stack>
                      <Toggle
                        inlineLabel
                        onText={t('paymentMethods.on')}
                        offText={t('paymentMethods.off')}
                        checked={paymentDisplay}
                        styles={{ root: { width: 80, padding: "5px 0px" } }}
                        onChange={() => {
                          if (paymentDisplay) {
                            setPaymentDisplay(false);
                            setPromptpay(false);
                          } else {
                            setPaymentDisplay(true);
                          }
                        }}
                      />
                    </Stack>
                    <Stack horizontal horizontalAlign='space-between'>
                      <Stack>
                        <label style={{ fontWeight: 600, color: "#323130", padding: "5px 0px"}}>{t('paymentMethods.english')}</label>
                      </Stack>
                      <Toggle
                        inlineLabel
                        onText={t('paymentMethods.on')}
                        offText={t('paymentMethods.off')}
                        styles={{ root: { width: 80, padding: "5px 0px" } }}
                        checked={paymentLanguage === 'en' ? true : false}
                        onChange={() => {
                          if (paymentLanguage === 'en') {
                            setPaymentLanguage('th');
                          } else {
                            setPaymentLanguage('en');
                          }
                        }}
                      />
                    </Stack>
                    <Stack horizontal horizontalAlign='space-between'>
                      <Stack>
                        <label style={{ fontWeight: 600, color: paymentDisplay ? "#323130" : "#A19F9D", padding: "5px 0px"}}>{t('paymentMethods.displayPromptpay')}</label>
                      </Stack>
                      <Toggle
                        inlineLabel
                        onText={t('paymentMethods.on')}
                        offText={t('paymentMethods.off')}
                        styles={{ root: { width: 80, padding: "5px 0px" } }}
                        checked={promptpay}
                        disabled={!paymentDisplay}
                        onChange={() => {
                          setPromptpay(!promptpay);
                        }}
                      />
                    </Stack>
                    <TextField 
                      label={t('paymentMethods.accountName')}
                      value={accountName}
                      onChange={(e) => setAccountName(e.target.value)}
                    />
                    {banks.map((bank, index) => {
                      return (
                        <div key={index}>
                          <Stack horizontal>
                            <br />
                            <Dropdown
                              placeholder={t('paymentMethods.pleaseSelect')}
                              label={t('paymentMethods.bankName')}
                              options={bankList}
                              styles={{
                                root: {
                                  width: 150,
                                  marginRight: 15,
                                },
                              }}
                              selectedKey={banks[index]['bankCode']}
                              onChange={(event, selectedOption) => {
                                console.log(selectedOption);
                                handleChangeBankName(index, event, selectedOption);
                              }}
                              errorMessage={showBankError ? getErrorMessageDropdown(banks[index]['bankCode'], true) : ""}
                            />
                            <TextField
                              name="branch"
                              label={t('paymentMethods.bankBranch')}
                              styles={{
                                root: {
                                  width: 120,
                                  marginRight: 15,
                                },
                              }}
                              maxLength={140}
                              onChange={(event) => {
                                handleChangeBank(index, event);
                              }}
                              value={banks[index]['branch']}
                              errorMessage={showBankError ? getErrorMessage(banks[index]['branch'], true) : ""}
                            />
                            <Dropdown
                              placeholder={t('paymentMethods.pleaseSelect')}
                              label={t('paymentMethods.accountType')}
                              options={accountTypeList}
                              styles={{
                                root: {
                                  width: 120,
                                  marginRight: 15,
                                },
                              }}
                              selectedKey={banks[index]['typeCode']}
                              onChange={(event, selectedOption) => {
                                console.log(selectedOption);
                                handleChangeBankType(index, event, selectedOption);
                              }}
                              errorMessage={showBankError ? getErrorMessageDropdown(banks[index]['typeCode'], true) : ""}
                            />
                            <TextField
                              name="accountNumber"
                              label={t('paymentMethods.accountNumber')}
                              styles={{
                                root: {
                                  width: 150,
                                },
                              }}
                              maxLength={35}
                              onChange={(event) => {
                                handleChangeBank(index, event);
                              }}
                              value={banks[index]['accountNumber']}
                              errorMessage={showBankError ? getErrorMessage(banks[index]['accountNumber'], true) : ""}
                            />
                            <IconButton
                              iconProps={{
                                iconName: 'Delete',
                              }}
                              title={t('paymentMethods.delete')}
                              style={{
                                marginTop: 30,
                              }}
                              onClick={() => handleRemoveBank(index)}
                            />
                          </Stack>
                        </div>
                      );
                    })}
                    
                    <center>
                      <br />
                      <PrimaryButton
                        iconProps={{ iconName: 'Add' }}
                        style={{ letterSpacing: '1px' }}
                        name="addBank"
                        text={t('paymentMethods.addBank')}
                        onClick={() => handleAddBank()}
                      />
                      <br />
                    </center>
                    <TextField
                      name="paymentNote"
                      label={t('paymentMethods.paymentNote')}
                      onChange={(e) => {
                        setPaymentNote(e.target.value);
                      }}
                      value={paymentNote}
                    />
                    <div>
                      <br />
                      <Separator />
                      <br />
                    </div>
                    <center>
                      <PrimaryButton
                        name="save"
                        text={t('paymentMethods.save')}
                        iconProps={{ iconName: 'Save' }}
                        onClick={(e) => handleSubmitPayment(e)}
                      />
                    </center>
                  </div>
                </form>
                <br />
                <br />
              </div>
            )
          ) : null}
          {currentTab === "billPayment" ? (
            isLoading ? (
              <Stack>
                <Stack horizontal horizontalAlign="center" style={{ marginTop: '25px', width: 617 }}>
                  <br />
                  <br />
                  <div>
                    <Spinner label={t('paymentMethods.loading')} labelPosition="down" styles={spinnerStyles} />
                  </div>
                  <br />
                </Stack>
              </Stack>
            ) : (
              <div>
                <form>
                  {notSubscribed ? (
                    <div style={{...cardStyle, width: 617}}>
                      <h2>
                        {" "}
                        {t("paymentMethods.youNotSubscriber")}
                      </h2>
                      <p>
                        {t("paymentMethods.toAccessPlease")}
                      </p>
                      <center>
                        <PrimaryButton text={t("paymentMethods.goToHomepage")} onClick={() => history.push("/etax/documents/all")} />
                      </center>
                    </div>
                  ) : (
                    !enableBillPayment ? (
                      <div style={{...cardStyle, width: 617}}>
                        <h2>
                          {" "}
                          {t("paymentMethods.cannotUseThisFeature")}
                        </h2>
                        <p>
                          {t("paymentMethods.toAccessPlease")}
                        </p>
                        <center>
                          <PrimaryButton text={t("paymentMethods.goToHomepage")} onClick={() => history.push("/etax/documents/all")} />
                        </center>
                      </div>
                    ) : (
                      <div style={cardStyle}>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack>
                            <label style={{ fontWeight: 600, color: "#323130", padding: "5px 0px"}}>{t('paymentMethods.displayBillPayment')}</label>
                          </Stack>
                          <Toggle
                            inlineLabel
                            onText={t('paymentMethods.on')}
                            offText={t('paymentMethods.off')}
                            styles={{ root: { width: 80, padding: "5px 0px" } }}
                            checked={displayBillPayment}
                            onChange={() => {
                              if (displayBillPayment) {
                                setDisplayBillPayment(false);
                              } else {
                                setDisplayBillPayment(true);
                              }
                            }}
                          />
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack>
                            <label style={{ fontWeight: 600, color: "#323130", padding: "5px 0px"}}>{t('paymentMethods.specificAmount')}</label>
                          </Stack>
                          <Toggle
                            inlineLabel
                            onText={t('paymentMethods.on')}
                            offText={t('paymentMethods.off')}
                            styles={{ root: { width: 80, padding: "5px 0px" } }}
                            checked={enabledSpecificAmount}
                            onChange={() => {
                              if (enabledSpecificAmount) {
                                setEnabledSpecificAmount(false);
                              } else {
                                setEnabledSpecificAmount(true);
                              }
                            }}
                          />
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack>
                            <label style={{ fontWeight: 600, color: "#323130", padding: "5px 0px"}}>{t('paymentMethods.reference')}</label>
                          </Stack>
                          <Toggle
                            inlineLabel
                            onText={t('paymentMethods.on')}
                            offText={t('paymentMethods.off')}
                            styles={{ root: { width: 80, padding: "5px 0px" } }}
                            checked={enabledReference}
                            onChange={() => {
                              if (enabledReference) {
                                setEnabledReference(false);
                              } else {
                                setEnabledReference(true);
                              }
                            }}
                          />
                        </Stack>
                        <TextField 
                          label={t('paymentMethods.taxId')}
                          componentRef={(input) => (refArray.current.taxId = input)}
                          value={taxId}
                          maxLength={13}
                          styles={{ root: { width: 617 }}}
                          onChange={(e) => setTaxId(e.target.value)}
                          onGetErrorMessage={(value) => getErrorMessageNoMaxLength(value, true, value.length !== 13 ? t('paymentMethods.getTaxIdErrorMessage') : '')}
                          validateOnLoad={false}
                          validateOnFocusOut
                          required
                        />
                        <TextField 
                          label={t('paymentMethods.suffix')}
                          componentRef={(input) => (refArray.current.suffix = input)}
                          value={suffix}
                          maxLength={2}
                          onChange={(e) => setSuffix(e.target.value)}
                          onGetErrorMessage={(value) => getErrorMessageNoMaxLength(value, true, value.length !== 2 ? t('paymentMethods.getSuffixErrorMessage') : '')}
                          validateOnLoad={false}
                          validateOnFocusOut
                          required
                        />
                        {enabledReference ? (
                          <>
                            <TextField 
                              label={t('paymentMethods.ref1')}
                              componentRef={(input) => (refArray.current.ref1 = input)}
                              value={ref1}
                              maxLength={18}
                              onChange={(e) => setRef1(e.target.value.replace(/\D/g, ""))}
                              onBlur={(e) => {
                                if (!e.target.value.trim()) {
                                  setRef1('');
                                } else {
                                  setRef1(e.target.value.trim());
                                }
                              }}
                              onGetErrorMessage={(value) => getErrorMessageWithMaxLength(value, 18, true)}
                              validateOnLoad={false}
                              validateOnFocusOut
                              required
                            />
                            <TextField 
                              label={t('paymentMethods.ref2')}
                              componentRef={(input) => (refArray.current.ref2 = input)}
                              value={ref2}
                              maxLength={18}
                              onChange={(e) => setRef2(e.target.value.replace(/\D/g, ""))}
                              onBlur={(e) => {
                                if (!e.target.value.trim()) {
                                  setRef2('');
                                } else {
                                  setRef2(e.target.value.trim());
                                }
                              }}
                              onGetErrorMessage={(value) => getErrorMessageWithMaxLength(value, 18, true)}
                              validateOnLoad={false}
                              validateOnFocusOut
                              required
                            />
                          </>
                        ) : null}
                        <div>
                          <br />
                          <Separator />
                          <br />
                        </div>
                        <center>
                          <PrimaryButton
                            name="save"
                            text={t('paymentMethods.save')}
                            iconProps={{ iconName: 'Save' }}
                            disabled={enabledReference && (!ref1 || !ref2)}
                            onClick={(e) => handleSubmit(e)}
                          />
                        </center>
                      </div>
                    )
                  )}
                </form>
                <br />
                <br />
              </div>
            )
          ) : null}
          <br />
          <br />

        </Stack>
      </Stack>
    </div>
  );
};

export default PaymentMethods;
